import styled from 'styled-components'

import { theme } from 'styles/theme'

const { borderWidths, colors, media, radii, space } = theme

export const TrustBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};
  width: 100%;

  @media (${media.tablet}) {
    flex-direction: row;
    align-items: stretch;
    justify-content: center;
    gap: 0;
    width: fit-content;
    margin: 0 auto;
    padding: ${space['spacing-md']} ${space['spacing-xxl']};
    background-color: ${colors['blue-background-strong-default']};
    border-radius: ${radii['corner-radius-md']};
  }
`

export const Item = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  padding: ${space['spacing-md']};
  text-align: center;
  background-color: ${colors['blue-background-strong-default']};
  border: ${borderWidths['border-stroke-micro']} solid ${`${colors['cyan-icon-hover']}80`};
  border-radius: ${radii['corner-radius-lg']};

  @media (${media.phone}) {
    width: 60vw;
    max-width: 16rem;
    height: 6rem;
    padding: ${space['spacing-sm']};
  }

  @media (${media.tablet}) {
    padding: ${space['spacing-sm']} ${space['spacing-xxl']};
    background-color: transparent;
    border: none;
    border-radius: 0;

    &:not(:last-child)::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 0;
      width: 1px;
      height: ${space['spacing-xl']};
      transform: translateY(-50%);
      background-color: #ffffff40;
    }
  }
`

export const MobileCarousel = styled.div`
  width: 100%;

  .swiper-slide {
    width: auto;
    height: auto;
  }

  .swiper-wrapper {
    transition-timing-function: linear !important;
  }
`

export const Brand = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['spacing-xxs']};
`

export const Credit = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  > * {
    line-height: 1.15;
  }
`
